'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryButton = function (_Component) {
  _inherits(BinaryButton, _Component);

  function BinaryButton(props) {
    _classCallCheck(this, BinaryButton);

    var _this = _possibleConstructorReturn(this, (BinaryButton.__proto__ || Object.getPrototypeOf(BinaryButton)).call(this, props));

    _this.styles = require('./BinaryButton.scss');
    return _this;
  }

  _createClass(BinaryButton, [{
    key: 'getButton',
    value: function getButton() {
      var _props = this.props,
          id = _props.id,
          icon = _props.icon,
          disabled = _props.disabled,
          style = _props.style,
          raisedEffect = _props.raisedEffect,
          label = _props.label;

      var className = raisedEffect ? 'binary_button ' + this.styles.binary_button + ' ' + this.styles.raised : 'binary_button ' + this.styles.binary_button + ' ' + this.styles.no_raised;
      return _react2.default.createElement(
        'button',
        {
          id: id,
          disabled: disabled,
          style: style,
          onTouchTap: this.handleTouchTap.bind(this),
          className: className },
        icon,
        label
      );
    }
  }, {
    key: 'getStyle',
    value: function getStyle() {
      var style = {};
      style.marginLeft = '-16px';
      if (this.props.indicator > 10) {
        style.marginLeft = '-18px';
      }
      if (this.props.indicator > 99) {
        style.fontSize = '0.4em';
        style.marginTop = '12px';
        style.marginLeft = '-20px';
      }
      return style;
    }
  }, {
    key: 'handleTouchTap',
    value: function handleTouchTap(event) {
      event.preventDefault();
      var _props2 = this.props,
          disabled = _props2.disabled,
          onClick = _props2.onClick,
          onTouchTap = _props2.onTouchTap;

      if (onClick && !disabled) {
        onClick(event);
      }
      if (onTouchTap && !disabled) {
        onTouchTap(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          indicator = _props3.indicator,
          indicatorId = _props3.indicatorId,
          className = _props3.className;


      return _react2.default.createElement(
        'div',
        { className: className !== undefined ? className + ' ' + this.styles.binary_button_container : this.styles.binary_button_container },
        this.getButton(),
        indicator !== 0 && _react2.default.createElement(
          'span',
          { className: 'binary_button_indicator ' + this.styles.binary_button_indicator },
          _react2.default.createElement('i', { className: 'fa fa-circle' }),
          _react2.default.createElement(
            'span',
            { style: this.getStyle(), id: indicatorId, className: String(indicator).length === 1 ? this.styles.binary_button_number_single : this.styles.binary_button_number },
            indicator
          )
        )
      );
    }
  }]);

  return BinaryButton;
}(_react.Component);

BinaryButton.propTypes = {
  id: _propTypes2.default.string,
  icon: _propTypes2.default.object,
  indicator: _propTypes2.default.number,
  label: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  onClick: _propTypes2.default.func,
  onTouchTap: _propTypes2.default.func,
  className: _propTypes2.default.string,
  indicatorId: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  raisedEffect: _propTypes2.default.bool,
  style: _propTypes2.default.object
};
BinaryButton.defaultProps = {
  id: 'binary_button_' + Math.random(),
  indicatorId: 'binary_button_' + Math.random(),
  indicator: 0,
  raisedEffect: false,
  disabled: false
};
exports.default = BinaryButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryButton/BinaryButton.js
// module id = 331
// module chunks = 1